var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./MemberProfileEditExperienceItem.jinja');
require('./MemberProfileEditExperienceItem.less');

module.exports = Base.extend({

    template: template,

    events: {
        'click .MemberProfileEditExperienceItem-inputIcons-delete': 'deleteExperience'
    },


    initialize: function (options) {
        this.options = options || {};

        Base.prototype.initialize.call(this, options);
    },


    deleteExperience: function (e) {
        this.remove();

        window.app.vent.trigger('MemberProfileEditExperienceItem-remove');
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/MemberProfileEdit/MemberProfileEditExperienceItem.js
// module id = 213
// module chunks = 0